(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-th-open-rewards]');
    if (!trigger) return;

    const rewardsLauncher = document.querySelector('._LabelLauncher_q8pf8_1');
    if (!rewardsLauncher) return;

    const drawer = trigger.closest('details.th-mobile-nav');
    if (drawer) drawer.open = false;

    rewardsLauncher.click();
  });
  } catch(e) { console.error(e); }
})();

})();
